module.exports = __webpack_public_path__ + "img/SCCC.fa1d2e4d.jpg";